import auth from "../../middlewares/auth";
export const thinkingSkillRoute = [
  {
    path: '/lecture/thinking-skill/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/ThinkingSkillList'),
    name: 'thinking_skill_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/thinking-skill/top-solution/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/TopSolutionForm'),
    name: 'thinking_skill_top_solution_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/thinking-skill/top-solution/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/TopSolutionForm'),
    name: 'thinking_skill_top_solution_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/thinking-skill/thinking-ability/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/ThinkingAbilityForm'),
    name: 'thinking_skill_thinking_ability_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/thinking-skill/thinking-ability/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/ThinkingAbilityForm'),
    name: 'thinking_skill_thinking_ability_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/thinking-skill/examination/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/ExaminationForm'),
    name: 'thinking_skill_examination_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/thinking-skill/examination/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/thinking_skill/ExaminationForm'),
    name: 'thinking_skill_examination_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
];